module.exports = __webpack_public_path__ + "static/media/poste_27.a6e30444.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_27.jpg
// module id = 256
// module chunks = 0